import { render, staticRenderFns } from "./v_About.vue?vue&type=template&id=3e84606e&scoped=true&"
import script from "./v_About.vue?vue&type=script&lang=js&"
export * from "./v_About.vue?vue&type=script&lang=js&"
import style0 from "./v_About.vue?vue&type=style&index=0&id=3e84606e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e84606e",
  null
  
)

export default component.exports